export const adjustProfileData = data => {
  const user = data.userId;
  const role = data.roleId;
  const company = data.companyId;

  let newData = {};

  if (role && role.role) {
    newData.role = role.role;
  }
  if (role && role.roleKey) {
    newData.roleKey = role.roleKey;
  }

  if (user.lastname) {
    newData.lastname = user.lastname;
  }
  if (user.name) {
    newData.name = user.name;
  }
  if (user.patronymic) {
    newData.patronymic = user.patronymic;
  }
  if (user.birthDate) {
    newData.birthDate = user.birthDate;
  }
  if (user.phone) {
    let phone = user.phone.match(
      /^(\+7|\+380|\+375|\+995|\+374|\+994|\+77|)(.*)/
    );

    if (phone) {
      newData.phoneCode = phone[1];
      newData.phoneNumber = phone[2];
    }
  }
  if (user.email) {
    newData.email = user.email;
  }
  if (user.photo) {
    newData.photo = user.photo;
  }
  if (company && company.companyId) {
    newData.companyId = company.companyId;
  }

  return newData;
};
